import React, { useState } from "react";
import { Box, makeStyles } from "@material-ui/core";
import Text from "../Text";
import Colors from "../../../helpers/Colors";
import { Tab, Tabs, TabList } from "react-tabs";
import assets from "../../../helpers/assets";
import { DeliveryMethod } from "./DeliveryMethod";
import { SelfManagedMode } from "./SelfManagedMode";
import { getFromStorage } from "../../../services/LocalStorage";
import {
  STORAGE_KEY_IS_USING_RULE_BASED_CONFIG
} from "../../../helpers/Constants";

export function SettingsTabView() {
  const classes = useStyles();
  const TAB_TYPE_DELIVERY_METHOD = 'DELIVERY_METHOD';
  const TAB_TYPE_DELIVERY_REQUEST = 'DELIVERY_REQUEST';
  const TAB_DELIVERY_METHOD = {
    type: TAB_TYPE_DELIVERY_METHOD,
    name: "Delivery Method",
    icon: assets.helmet.default
  };
  const TAB_DELIVERY_REQUEST = {
    type: TAB_TYPE_DELIVERY_REQUEST,
    name: "Delivery Request",
    icon: assets.bell.default
  };

  const [selectedTab, setSelectedTab] = useState(
    getFromStorage(STORAGE_KEY_IS_USING_RULE_BASED_CONFIG)
      ? TAB_TYPE_DELIVERY_REQUEST : TAB_TYPE_DELIVERY_METHOD);
  const [tabs] = useState(
    getFromStorage(STORAGE_KEY_IS_USING_RULE_BASED_CONFIG)
      ? [TAB_DELIVERY_REQUEST]
      : [TAB_DELIVERY_METHOD]);

  const renderContent = (selected) => {
    switch (selected) {
      case TAB_TYPE_DELIVERY_METHOD:
        return <DeliveryMethod />
      case TAB_TYPE_DELIVERY_REQUEST:
        return <SelfManagedMode />
      default:
        return null;
    }
  }

  const renderTabBox = (tabData, selected) => {
    return <Tab
      className={
        tabData.type === selected
          ? classes.selectedTabButtonContainer
          : classes.tabButtonContainer
      }
      onClick={() => setSelectedTab(tabData.type)}
    >
      <Box
        className={classes.tabButtonContentContainer}>
        <img
          src={tabData.icon}
          alt=""
          className={classes.tabButtonIcon}
        />
        <Text
          className={tabData.type === selected
            ? classes.selectedTabLabel
            : classes.tabLabel}
        >
          {tabData.name}
        </Text>
      </Box>
    </Tab>
  }

  return (
    <Tabs
      orientation="vertical"
      style={{ display: "flex", width: "100%", overflow: "hidden" }}
    >
      <TabList style={{ backgroundColor: "#F6F6F6", overflow: "hidden" }}>
        <Box className={classes.tabsContainer}>
          <div style={{ height: 10, backgroundColor: "white" }}></div>
          {tabs.map(tab => renderTabBox(tab, selectedTab))}

          <Box className={classes.logoBox}>
            <img
              src={assets.logoBlack.default}
              alt=""
              className={classes.logoBlack}
            />
          </Box>
          
        </Box>
      </TabList>
      <div style={{ flex: 1, height: "100%" }}>
        <div className={classes.displayPanel}>
          {renderContent(selectedTab)}
        </div>
      </div>
    </Tabs>
  );
}

const useStyles = makeStyles((_) => ({
  tabLabel: {
    color: Colors.textColor,
    fontSize: 16,
    fontFamily: "SFProDisplay-Medium",
  },
  selectedTabLabel: {
    color: Colors.textColor,
    fontSize: 16,
    fontFamily: "SFProDisplay-Medium",
  },
  tabsContainer: {
    height: "100vh",
    maxWidth: 240,
    borderRight: "1px solid #EDEDED",
  },
  tabButtonContainer: {
    cursor: "pointer",
    display: "flex",
    flexDirection: "row",
    height: 72,
    paddingLeft: 25,
    alignItems: "center",
  },
  selectedTabButtonContainer: {
    cursor: "pointer",
    display: "flex",
    flexDirection: "row",
    width: "25vw",
    height: 72,
    paddingLeft: 25,
    alignItems: "center",
    backgroundColor: "rgba(75, 179, 239, 0.2)",
  },
  tabButtonContentContainer: {
    display: "flex",
    direction: "row",
    alignItems: "center",
  },
  tabButtonIcon: {
    width: 20,
    height: 20,
    marginRight: 16,
  },
  displayPanel: {
    height: "100%",
    width: "100%",
    zIndex: 1,
  },
  hidePanel: {
    height: "100%",
    width: "100%",
    zIndex: -1,
    display: "none",
  },
  logoBlack: {
    height: 30,
    width: 250,
    objectFit: 'contain',
  },
  logoSection: {
    display: 'flex',
    flex: 2,
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  logoBox: {
    height: 35,
    width: 35,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 45,
    position:'fixed',
    bottom: 10,
    left: 5
  },
}));
